import type { RoiFilterStep, RoiFilterStrategyContext } from './roi-filter.types';

export function applyScoreFilter(step: RoiFilterStep, ctx: RoiFilterStrategyContext): Set<string> | undefined {
  const filterScore = Number(step.value.replace('%', '')) / 100;
  const filteredRois = ctx.previousRois.filter((roi) =>
    Array.from(roi.labels.values()).some((score) => (step.operator === '>' ? score > filterScore : score < filterScore))
  );
  return new Set(filteredRois.map((roi) => roi.id));
}
